import React, { useEffect, useState } from 'react'
import { virtualMallWithdrawalListApi, virtualMallWithdrawApi, virtualMallWithdrawRequestApi } from './VirtualMallApi/api'
import './VirtualMallWithdraw.scss'
import { toast } from 'react-toastify'

const VirtualMallWithdraw = () => {

    const [withdrawList, setWithdrawList] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [stats, setStats] = useState({
        totalWithdrawn: 0,
        pendingRequests: 0,
        approvedRequests: 0
    })

    useEffect(() => {
        getWithdrawList()
    }, [])

    const getWithdrawList = async () => {
        try {
            setLoading(true)
            const res = await virtualMallWithdrawalListApi()
            if (res && res.data) {
                // API might return a single object or an array
                const list = Array.isArray(res.data) ? res.data : [res.data]
                setWithdrawList(list)
                calculateStats(list)
            }
        } catch (error) {
            setError(error)
            toast.error("Failed to load withdrawal history")
        } finally {
            setLoading(false)
        }
    }

    const calculateStats = (list) => {
        let total = 0
        let pending = 0
        let approved = 0

        list.forEach(item => {
            if (!item) return; // safety check
            const amount = parseFloat(item.vwithdraw_amount || 0)
            const status = (item.vwithdraw_status || '').toLowerCase()

            if (status === 'approved') {
                total += amount
                approved++
            } else if (status === 'pending') {
                pending++
            }
        })

        setStats({
            totalWithdrawn: total,
            pendingRequests: pending,
            approvedRequests: approved
        })
    }



    return (
        <div className="dashboard-section virtual-mall-withdraw">
            <div className="dashboard-header">
                <h2>Withdrawal List</h2>
            </div>

            {/* Stats Section */}
            <div className="stats-grid">
                <div className="stat-card">
                    <div className="stat-icon">💰</div>
                    <div className="stat-content">
                        <div className="stat-value">₹{stats.totalWithdrawn.toFixed(2)}</div>
                        <div className="stat-label">Total Withdrawn</div>
                    </div>
                </div>
                <div className="stat-card">
                    <div className="stat-icon">⏳</div>
                    <div className="stat-content">
                        <div className="stat-value">{stats.pendingRequests}</div>
                        <div className="stat-label">Pending Requests</div>
                    </div>
                </div>
                <div className="stat-card">
                    <div className="stat-icon">✅</div>
                    <div className="stat-content">
                        <div className="stat-value">{stats.approvedRequests}</div>
                        <div className="stat-label">Approved Requests</div>
                    </div>
                </div>
            </div>

            <div className="table-section">
                <h3>Withdrawal History</h3>
                <div className="table-responsive">
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {withdrawList.length > 0 ? (
                                withdrawList.map((item, index) => {
                                    if (!item) return null;
                                    const statusClass = (item.vwithdraw_status || '').toLowerCase();
                                    return (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td className="fw-bold">₹{item.vwithdraw_amount}</td>
                                            <td>
                                                <span className={`status-badge ${statusClass}`}>
                                                    {item.vwithdraw_status}
                                                </span>
                                            </td>
                                            <td>{new Date(item.vwithdraw_createdat).toLocaleDateString()}</td>

                                        </tr>
                                    )
                                })
                            ) : (
                                <tr>
                                    <td colSpan="5" className="text-center">No withdrawal history found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div >
    )
}

export default VirtualMallWithdraw
